import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { Store } from '@ngrx/store';
import { loadServices, loadSubpages } from './store/actions/app.actions';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    FooterComponent
  ],
  template: `
    <router-outlet />
  `,
  providers: []
})
export class AppComponent {

  constructor(
    private store$: Store
  ) {
    this.store$.dispatch(loadServices());
    this.store$.dispatch(loadSubpages());
  }

}
